import React from "react"
import "./buttons.css"

function PrimaryCTA(props) {
    return (
        <div className={`button primary ${props.class}`}>
            <div className="button-text">{props.text}</div>
        </div>
    )
}
export default PrimaryCTA